import script from "./TagLock.vue?vue&type=script&setup=true&lang=js"
export * from "./TagLock.vue?vue&type=script&setup=true&lang=js"

import "./TagLock.vue?vue&type=style&index=0&id=e2ef1eb4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2ef1eb4"]])

export default __exports__